import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Dialog, F0Text } from '@factorialco/f0-react'
import {
  LeavePostsGroupDocument,
  MyCommunitiesDocument,
  OtherCommunitiesDocument,
  PostsGroupHeaderDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  onClose: () => void
  groupId: number
}

function LeaveGroup({ onClose, groupId }: Props) {
  const [running, setRunning] = React.useState(false)

  const { data, loading } = useQuery(PostsGroupHeaderDocument, {
    variables: {
      id: groupId,
    },
  })

  const group = data?.posts.group

  const [leaveGroup] = useMutation(LeavePostsGroupDocument, {
    extractorFn: (mutationData) => mutationData.postsMutations.leavePostsGroup,
  })

  React.useEffect(() => {
    if (!loading && !group) {
      onClose()
    }
  }, [loading, group, onClose])

  const handleSubmit = async () => {
    if (!group) return

    setRunning(true)

    const result = await leaveGroup({
      variables: {
        id: groupId,
      },
      refetchQueries: [
        {
          query: PostsGroupHeaderDocument,
          variables: { id: groupId },
        },
        {
          query: MyCommunitiesDocument,
        },
        {
          query: OtherCommunitiesDocument,
        },
      ],
    })

    const handled = handleResult(result, (_errors) => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('posts.communities.error_message'),
      })
    })

    setRunning(false)

    if (handled.success) {
      onClose()
    }
  }

  return (
    <F0Dialog
      isOpen
      onClose={onClose}
      title={i18n.t('dashboard.groups.leave.title')}
      width="sm"
      primaryAction={{
        label: i18n.t('dashboard.groups.leave.title'),
        onClick: handleSubmit,
        disabled: !group || running,
        loading: running,
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
        disabled: running,
      }}
      loading={loading}
    >
      <Box gap="s16">
        <F0Text content={i18n.t('dashboard.groups.leave.description')} />
      </Box>
    </F0Dialog>
  )
}

export default LeaveGroup
